const routes = [
  {
    path: '/referral/validity',
    component: () => import('@/views/provider/referralValidity/Main.vue'),
  },
];

export default routes;
